(function () {
  var videoBlocks = document.querySelectorAll('.video-block');
  videoBlocks.forEach(function (videoBlock) {
    var playButton = videoBlock.querySelector('.video-block__play svg');
    var video = videoBlock.querySelector('video');
    if (playButton) {
      playButton.addEventListener('click', function () {
        video.play();
        videoBlock.classList.add('playing');
      });
    }
    if (video) {
      video.addEventListener('click', function () {
        video.pause();
        videoBlock.classList.remove('playing');
      });
    }
  });
})();